/********* SAMPLE DATA **********/
const SCHEDULE_DATE_BASE = new Date('2020/02/05 00:00:00');
const _dayshift = (from) => {
	let today = new Date();
	today.setHours(0);
	today.setMinutes(0);
	today.setSeconds(0);
	let diff_days = Math.trunc((today - SCHEDULE_DATE_BASE) / 1000 / 3600 / 24);

	return from.addDays(diff_days);
};
const CLASS = [
	{code: '100', seq: 1, is_updated: 0, name: 'チームA'},
	{code: '101', seq: 2, is_updated: 0, name: 'チームB'},
	{code: '102', seq: 3, is_updated: 0, name: 'チームC'},
	{code: '103', seq: 4, is_updated: 0, name: '現場管理者-渡辺'},
	{code: '104', seq: 5, is_updated: 0, name: '現場管理者-佐々木'},
	{code: '105', seq: 6, is_updated: 0, name: '現場管理者-小川'},
];
const MEMBER = [
	{code: '200', name: '佐藤　一郎', tel: '090-0000-0000', login_id: 'aaaaaa', login_passwd: 'coa3550', permission: 15, seq: 1, remarks: '', invalid: 0, is_updated: 0, comment: '終日社内にいます', classes: []},
	{code: '201', name: '田中　健人', tel: '090-1111-1111', login_id: 'bbbbbb', login_passwd: 'coa3550', permission: 7, seq: 2, remarks: '', invalid: 0, is_updated: 0, comment: '13時にお客様来社予定です', classes: ['100', '101', '102']},
	{code: '202', name: '渡辺　和夫', tel: '090-3333-3333', login_id: 'dddddd', login_passwd: 'coa3550', permission: 3, seq: 4, remarks: '', invalid: 0, is_updated: 0, comment: '洗浄機工事日程調整中です', classes: ['100', '103']},
	{code: '203', name: '佐々木　進', tel: '090-4444-0000', login_id: 'eeeeee', login_passwd: 'coa3550', permission: 3, seq: 5, remarks: '', invalid: 0, is_updated: 0, comment: '現場へ直行します', classes: ['101', '104']},
	{code: '204', name: '小川　裕之', tel: '090-5555-1111', login_id: 'ffffff', login_passwd: 'coa3550', permission: 3, seq: 6, remarks: '', invalid: 0, is_updated: 0, comment: '通院のため9時に出社予定', classes: ['102', '105']},
	{code: '205', name: '玉口　浩二', tel: '090-6666-2222', login_id: 'iiiiii', login_passwd: 'coa3550', permission: 2, seq: 9, remarks: '', invalid: 0, is_updated: 0, comment: '', classes: ['100']},
	{code: '206', name: '荒井　大翔', tel: '090-7777-3333', login_id: 'jjjjjj', login_passwd: 'coa3550', permission: 1, seq: 10, remarks: '', invalid: 0, is_updated: 0, comment: '', classes: ['102']},
];
const PROJECT = [
	{
		code: '304', 
		name: 'コアビル消火器点検', 
		seq: 1, 
		is_updated: 0, 
		schedules: [
			{
				code: '504',
				begin: '202002051300',
				end: '202002051500',
				all_day: 0,
			},
		],
		classes: ['102', '105'], 
		remarks: ''
	},
	{
		code: '305', 
		name: 'コアホテル消防設備点検', 
		seq: 2, 
		is_updated: 0, 
		schedules: [
			{
				code: '505',
				begin: '202002050900',
				end: '202002051200',
				all_day: 0,
			},
		],
		classes: ['100', '103'], 
		remarks: ''
	},
	{
		code: '303', 
		name: 'コア機械工場スレート屋根補修工事', 
		seq: 3, 
		is_updated: 0, 
		schedules: [
			{
				code: '503',
				begin: '202002050000',
				end: '202002052359',
				all_day: 1,
			},
		],
		classes: ['100', '101', '104'], 
		remarks: ''
	},
	{
		code: '302', 
		name: 'コア工場　壁補修工事', 
		seq: 4, 
		is_updated: 0, 
		schedules: [
			{
				code: '502',
				begin: '202002050000',
				end: '202002062359',
				all_day: 1,
			},
		],
		classes: ['102', '105'], 
		remarks: ''
	},
	{
		code: '301', 
		name: '〇〇エリア量水器設置工事', 
		seq: 5, 
		is_updated: 0, 
		schedules: [
			{
				code: '501',
				begin: '202002040000',
				end: '202002052359',
				all_day: 1,
			},
		],
		classes: ['101', '104'], 
		remarks: ''
	},
	{
		code: '300', 
		name: 'コアキッチン洗浄機更新工事', 
		seq: 6, 
		is_updated: 0, 
		schedules: [
			{
				code: '500',
				begin: '202002020000',
				end: '202002082359',
				all_day: 1,
			},
		],
		classes: ['100', '103'], 
		remarks: ''
	},
];

const TASK = [
	{
		code: '413', 
		name: '見積書作成', 
		project_code: '300',
		member_code: '202',
		schedules: [
			{
				code: '613',
				begin: '202002020800',
				end: '202002021000',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '414', 
		name: '現場確認', 
		project_code: '300',
		member_code: '202',
		schedules: [
			{
				code: '614',
				begin: '202002031300',
				end: '202002031500',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '415', 
		name: '洗浄機更新工事（日程調整中）', 
		project_code: '300',
		member_code: '202',
		schedules: [
			{
				code: '615',
				begin: '202002040000',
				end: '202002082359',
				all_day: 1,
			},
		],
		remarks: '日程調整中',
		is_updated: 0, 
	},
	{
		code: '422', 
		name: '社内事務', 
		project_code: '',
		member_code: '201',
		schedules: [
			{
				code: '622',
				begin: '202002050800',
				end: '202002050900',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '419', 
		name: '現場視察', 
		project_code: '305',
		member_code: '201',
		schedules: [
			{
				code: '619',
				begin: '202002050900',
				end: '202002051200',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '420', 
		name: '来客対応', 
		project_code: '',
		member_code: '201',
		schedules: [
			{
				code: '620',
				begin: '202002051300',
				end: '202002051400',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '421', 
		name: '社内事務', 
		project_code: '',
		member_code: '201',
		schedules: [
			{
				code: '621',
				begin: '202002051400',
				end: '202002051700',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '423', 
		name: '社内研修', 
		project_code: '',
		member_code: '202',
		schedules: [
			{
				code: '623',
				begin: '202002050800',
				end: '202002050900',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '400', 
		name: '設備点検', 
		project_code: '305',
		member_code: '202',
		schedules: [
			{
				code: '600',
				begin: '202002050900',
				end: '202002051200',
				all_day: 0,
			},
		],
		remarks: '同伴',
		is_updated: 0, 
	},
	{
		code: '424', 
		name: '社内事務', 
		project_code: '',
		member_code: '202',
		schedules: [
			{
				code: '624',
				begin: '202002051300',
				end: '202002051700',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '401', 
		name: '設備点検', 
		project_code: '305',
		member_code: '205',
		schedules: [
			{
				code: '601',
				begin: '202002050900',
				end: '202002051200',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '402', 
		name: '消火器点検', 
		project_code: '304',
		member_code: '206',
		schedules: [
			{
				code: '602',
				begin: '202002051300',
				end: '202002051500',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '412', 
		name: '設置工事', 
		project_code: '301',
		member_code: '203',
		schedules: [
			{
				code: '612',
				begin: '202002040800',
				end: '202002041700',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '411', 
		name: '設置工事', 
		project_code: '301',
		member_code: '203',
		schedules: [
			{
				code: '611',
				begin: '202002050800',
				end: '202002051200',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '403', 
		name: '補修工事', 
		project_code: '303',
		member_code: '203',
		schedules: [
			{
				code: '603',
				begin: '202002051300',
				end: '202002051700',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '404', 
		name: '補修工事', 
		project_code: '303',
		member_code: '205',
		schedules: [
			{
				code: '604',
				begin: '202002051300',
				end: '202002051700',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '425', 
		name: '書類整理', 
		project_code: '',
		member_code: '204',
		schedules: [
			{
				code: '625',
				begin: '202002050800',
				end: '202002051000',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '426', 
		name: '書類整理', 
		project_code: '',
		member_code: '206',
		schedules: [
			{
				code: '626',
				begin: '202002050800',
				end: '202002051000',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '405', 
		name: '現場確認', 
		project_code: '302',
		member_code: '204',
		schedules: [
			{
				code: '605',
				begin: '202002051000',
				end: '202002051200',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '406', 
		name: '現場確認', 
		project_code: '302',
		member_code: '206',
		schedules: [
			{
				code: '606',
				begin: '202002051000',
				end: '202002051200',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '427', 
		name: '打合せ準備', 
		project_code: '302',
		member_code: '204',
		schedules: [
			{
				code: '627',
				begin: '202002051300',
				end: '202002051500',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '407', 
		name: '打合せ', 
		project_code: '302',
		member_code: '204',
		schedules: [
			{
				code: '607',
				begin: '202002051500',
				end: '202002051700',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '408', 
		name: '打合せ', 
		project_code: '302',
		member_code: '206',
		schedules: [
			{
				code: '608',
				begin: '202002051500',
				end: '202002051700',
				all_day: 0,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '409', 
		name: '補修工事', 
		project_code: '302',
		member_code: '204',
		schedules: [
			{
				code: '609',
				begin: '202002060000',
				end: '202002062359',
				all_day: 1,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '410', 
		name: '補修工事', 
		project_code: '302',
		member_code: '206',
		schedules: [
			{
				code: '610',
				begin: '202002060000',
				end: '202002062359',
				all_day: 1,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '416', 
		name: '社内事務', 
		project_code: '',
		member_code: '200',
		schedules: [
			{
				code: '616',
				begin: '202002040000',
				end: '202002042359',
				all_day: 1,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '417', 
		name: '社内事務', 
		project_code: '',
		member_code: '200',
		schedules: [
			{
				code: '617',
				begin: '202002050000',
				end: '202002052359',
				all_day: 1,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
	{
		code: '418', 
		name: '社内事務', 
		project_code: '',
		member_code: '200',
		schedules: [
			{
				code: '618',
				begin: '202002060000',
				end: '202002062359',
				all_day: 1,
			},
		],
		remarks: '',
		is_updated: 0, 
	},
















];

/********************************/

import Vue from 'vue'
import Vuex from 'vuex'
import Class from './classes/Class';
import Member from './classes/Member';
import Task from './classes/Task';
import Schedule from './classes/Schedule';
import ScheduleTick from './classes/ScheduleTick';
import Util from './classes/Util';
import { LOGIN_USER_CODE } from './classes/Const';

import clonedeep from 'lodash/cloneDeep';

Vue.use(Vuex)

const createClasses = (relation_code, relation_type, classes) => {
	return classes.map(code => {
		let c = state.master.data_class.filter(c => c.code == code)[0];
		return new Class(Object.assign(Object.assign({}, c), {
			relation_code: relation_code,
			relation_type: relation_type,
		}));
	});
};
const createMembers = (members) => {
	return members.map(item => {
		let m = state.master.data_member.filter(m => m.code == item.code)[0];
		let tasks = new Array();
		state.data.data_task.forEach(t => {
			if (t.member_code == m.code) {
				let task_schedules = new Array();
				t.schedules.forEach( s => {
					task_schedules.push(s);
				});
				tasks.push(new Task(Object.assign(Object.assign({}, t)), {
					project_code: t.project_code,
					member_code: t.member_code,
					schedules: task_schedules,
				}));
			}
		});
		let schedules = new Array();
		tasks.forEach(task => {
			task.schedules.forEach(s => {
				schedules.push(s);
			});
		});
		return new Member(Object.assign(Object.assign({}, m), {
			children: tasks,
			schedules: schedules,
		}));
	});
};
const createSchedule = (project_code, member_code, task_code, schedules) => {
	return schedules.map(s => {
		return new Schedule({
			code: s.code,
			begin: _dayshift(new ScheduleTick({ code: s.begin })),
			end: _dayshift(new ScheduleTick({ code: s.end })),
			project_code: project_code,
			member_code: member_code,
			task_code: task_code,
			all_day: (s.all_day != 0),
		});
	});
};

const _findDataFromListProject = (project_code) => {
	let project = state.master.data_project.filter(p => p.code === project_code)[0];
	if (project === undefined) {
		return undefined;
	}
	return project;
};

const _findScheduleFromListProject = (schedule_code, project_code) => {
	let found = _findDataFromListProject(project_code);
	if (found === undefined)
		return undefined;

	let schedule = found.schedules.filter(s => s.code === schedule_code)[0];
	if (schedule === undefined) {
		return undefined;
	}

	return {
		schedule: schedule,
		project: found,
	};
};

const _findDataFromListTask = (task_code) => {
	let task = state.data.data_task.filter(t => t.code === task_code)[0];
	if (task === undefined) {
		return undefined;
	}
	return task;
};

const _findScheduleFromListTask = (schedule_code, task_code) => {
	let found = _findDataFromListTask(task_code);
	if (found === undefined)
		return undefined;

	let schedule = found.schedules.filter(s => s.code === schedule_code)[0];
	if (schedule === undefined) {
		return undefined;
	}

	return {
		schedule: schedule,
		task: found,
	};
};

const _createDateBeginningDay = function (state, date) {
	let return_date = new Date(date.getTime());
	return_date.setHours(date.getHours() - state.date_change_line.offset_hours);
	return_date.setHours(state.date_change_line.offset_hours);
	return_date.setMinutes(0);
	return_date.setSeconds(0);
	return return_date;
};

const state = {
	window: {
		size: {
			width: 0,
			height: 0,
			client_width: 0,
			client_height: 0,
		},
	},
	master: {
		data_member: [],
		data_class: [],
		data_project: [],
	},
	data: {
		data_task: [],
	},
	current_day: new Date(),
	date_change_line: {
		offset_hours: 0,	// [hours]
	},
};

const getters = {
	windowWidth: function(state) {
		return state.window.size.width;
	},
	windowHeight: function(state) {
		return state.window.size.height;
	},
	clientWidth: function(state) {
		return state.window.size.client_width;
	},
	clientHeight: function(state) {
		return state.window.size.client_height;
	},
	listMember: function(state) {
		return createMembers(state.master.data_member);
	},
	dataMember: function(state){
		return state.master.data_member;
	},
	dataClass: function(state){
		return state.master.data_class;
	},
	dataProject: function(state){
		return state.master.data_project;
	},
	dataTask: function(state){
		return state.data.data_task;
	},
	member: function(state){
		return (code) => {
			let dataMember = state.master.data_member.filter(m => { return m.code === code });
			if (dataMember.length > 0)
				return dataMember[0];
			return null;
		};
	},
	project: function(state){
		return (code) => {
			let dataProject = state.master.data_project.filter(p => { return p.code === code });
			if (dataProject.length > 0)
				return dataProject[0];
			return null;
		};
	},
	class: function(state){
		return (code) => {
			let dataClass = state.master.data_class.filter(p => { return p.code === code });
			if (dataClass.length > 0)
				return dataClass[0];
			return null;
		};
	},
	task: function(state){
		return (code) => {
			let dataTask = state.data.data_task.filter(t => { return t.code === code });
			if (dataTask.length > 0)
				return dataTask[0];
			return null;
		};
	},
	currentDate: function(state) {
		return state.current_day;
	},
	dateChangeLineOffsetHours: function(state) {
		return state.date_change_line.offset_hours;
	},
	createDateBeginningDay(state) {
		return (date) => {
			return _createDateBeginningDay(state, date);
		};
	},
	createDateCurrentBeginningDay(state, getters) {
		return _createDateBeginningDay(state, getters.currentDate);
	},
	//↓後で削除↓
	loginUser: function(state, getters) {
		return getters.member(LOGIN_USER_CODE);
	},
};

const mutations = {
	initState: function(state) {
		this.commit('chart/initState');
		this.commit('list/initState');
		
		state.current_day = new Date();
		state.date_change_line.offset_hours = 0;
	},
	setWindowSize: function(state, params) {
		state.window.size.width = params.width;
		state.window.size.height = params.height;
		state.window.size.client_width = params.client_width;
		state.window.size.client_height = params.client_height;
	},
	createData: function(state) {
		state.master.data_class = CLASS.map(c => {
			return {
				code: c.code,
				seq: c.seq,
				name: c.name,
				is_updated: (c.is_updated != 0),
			};
		});
		state.master.data_member = MEMBER.map(m => {
			return {
				code: m.code,
				name: m.name,
				tel: m.tel,
				comment: m.comment,
				classes: createClasses(m.code, Class.RELATION_TYPE.MEMBER, m.classes),
				remarks: m.remarks,
				login_id: m.login_id,
				login_passwd: m.login_passwd,
				invalid: m.invalid,
				permission: m.permission,
				seq: m.seq,
				is_updated: (m.is_updated != 0),
			};
		});
		state.master.data_project = PROJECT.map(p => {
			return {
				code: p.code,
				name: p.name,
				schedules: createSchedule(p.code, "", "", p.schedules),
				classes: createClasses(p.code, Class.RELATION_TYPE.PROJECT, p.classes),
				remarks: p.remarks,
				seq: p.code,
				is_updated: (p.is_updated != 0),
			}
		});
		state.data.data_task = TASK.map(t => {
			return {
				code: t.code,
				name: t.name,
				schedules: createSchedule(t.project_code, t.member_code, t.code, t.schedules),
				project_code: t.project_code,
				member_code: t.member_code,
				remarks: t.remarks,
				is_updated: (t.is_updated != 0),
			};
		});
	},
	updateSchedule: function(state, {schedule_code, project_code, task_code, begin_code, end_code, all_day}) {
		let found = null;
		if (task_code === '') {
			found = _findScheduleFromListProject(schedule_code, project_code);
			if (found === undefined)
				return;
		} else {
			found = _findScheduleFromListTask(schedule_code, task_code);
			if (found === undefined)
				return;
		}
		
		if (begin_code)
			found.schedule.begin.code = begin_code;
		if (end_code)
			found.schedule.end.code = end_code;
		if (all_day !== undefined)
			found.schedule.all_day = all_day ? 1 : 0;
	},
	addSchedule: function(state, {schedule}) {
		if (schedule.task_code === '') {
			let project = _findDataFromListProject(schedule.project_code);
			if (project === undefined)
				return;
			
			project.schedules.push(schedule);
		} else {
			let task = _findDataFromListTask(schedule.task_code);
			if (task === undefined)
				return;
			
			task.schedules.push(schedule);
		}
	},
	deleteSchedule: function(state, {schedule_code, project_code, task_code}) {
		let found = null;
		if (task_code === '') {
			found = _findDataFromListProject(project_code);
			if (found === undefined)
				return;
		} else {
			found = _findDataFromListTask(task_code);
			if (found === undefined)
				return;
		}
		
		Util.array_remove(found.schedules, schedule_code, (a, b) =>{ 
			return a.code === b;
		});
	},
	addTask: function(state, params) {
		if (params.member_code === undefined || params.member_code === null)
			params.member_code = '';
		if (params.project_code === undefined || params.project_code === null)
			params.project_code = '';
		
		let schedules = new Array();
		if (params.schedules === undefined || params.schedules === null) {
			schedules.push(Schedule.defaultSchedule({
				project_code: params.project_code,
				member_code: params.member_code,
				task_code: params.task_code,
				date: state.current_day,
			}));
		} else {
			schedules = params.schedules;
		}
		let task = {
			code: params.task_code,
			name: '新しいタスク',
			schedules: schedules,
			project_code: params.project_code,
			member_code: params.member_code,
			remarks: '',
			is_updated: true,
		};
		state.data.data_task.push(task);
	},
	deleteTask: function(state, code) {
		let task = state.data.data_task.filter( t => { return t.code === code })[0];
		if (!task)
			return;
		Util.array_remove(state.data.data_task, task, (a, b) =>{ 
			return a.code === b.code;
		});
	},
	setCurrentDate: function(state, date) {
		state.current_day = date;
	},
	addDaysCurrentDay: function(state, days) {
		let date = clonedeep(state.current_day);
		date.setDate(date.getDate() + days);
		state.current_day = date;
	},
	updateDataTask: function(state, value) {
		let task = state.data.data_task.filter( t => { return t.code === value.code })[0];
		if (!task)
			return;
		Object.assign(task, value);
	},
};

const actions = {
	updateSchedule: function(store, params) {
		store.commit('updateSchedule', params);
	},
	addTask: function(store, params) {
		store.commit('addTask', {
			task_code: params.task_code,
			project_code: params.project_code,
			member_code: params.member_code,
			schedules: params.schedules,
		});
	},
	addSchedule: function(store, params) {
		store.commit('addSchedule', params);
	},
	deleteSchedule: function(store, params) {
		store.commit('deleteSchedule', params);
	},
	setCurrentDate: function(store, params) {
		store.commit('setCurrentDate', params);
	},
	setCurrentDatePreviousDay: function(store) {
		store.commit('addDaysCurrentDay', -1);
	},
	setCurrentDateNextDay: function(store) {
		store.commit('addDaysCurrentDay', 1);
	},
	updateDataTask: function(store, value) {
		let task = store.getters.task(value.code);
		if (task) {
			store.commit('updateDataTask', value);
			return true;
		}
		return false;
	},
	deleteDataTask: function(store, code) {
		let task = store.getters.task(code);
		if (task) {
			store.commit('deleteTask', code);
			return true;
		}
		return false;
	},
};

import chart from './store/chart.js';
import list from './store/list.js';
import { strftime } from './classes/Const';
export default new Vuex.Store({
	state: state,
	getters: getters,
	mutations: mutations,
	actions: actions,
	modules: {
		chart: chart,
		list: list,
	},
})
export function convertDCLCode(date) {
	let return_code = '';
	let date_to_compare = new Date(date.getTime());
	date_to_compare.setHours(date_to_compare.getHours() - state.date_change_line.offset_hours);
	if (strftime('%Y%m%d%', date) === strftime('%Y%m%d%', date_to_compare)) {
		return_code = strftime('%Y%m%d%H%M', date);
	} else {
		let Ymd = strftime('%Y%m%d%', date_to_compare);
		let HH = String(date.getHours() + 24);
		let MM = strftime('%M', date);
		return_code = Ymd + HH + MM;
	}
	return return_code;
}
export function createDateBeginningDay(date) {
	return _createDateBeginningDay(state, date);
}
